/** @format */

import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from 'react-bootstrap';
import { globalServices } from '../../Services/global.service';
import { posServices } from '../../Services/pos.service';
import { useForm } from 'react-hook-form';
import { validationService } from '../../Services/validation.service';
import { ictNumber, numbersOnly } from '../../Config/Regex';

const ChangePos = ({ show, handleHide, posId, defaultValues }) => {
	const [reasons, setReasons] = useState([]);
	const [generateNewActivationCode, setGenerateNewActivationCode] =
		useState(true);
	const { t: translator } = useTranslation();
	const { register, handleSubmit, errors } = useForm();

	useEffect(() => {
		globalServices
			.getPosLogReasons()
			.then(res => setReasons(res.data))
			.catch(err => console.log(err));
	}, []);

	const confirmChange = data => {
		posServices
			.changePos(
				posId,
				data.posSerialNumber,
				data.inventoryNumber,
				//data.tid,
				data.msisdn,
				//`${data.msisdnCountry}${data.msisdnPrefix}${data.msisdn}`,
				data.note,
				Number(data.noteId),
				Boolean(generateNewActivationCode),
			)
			.then(res => {
				handleHide();
			})
			.catch(err => console.log(err));
	};

	return (
		<Modal size='lg' show={show} onHide={handleHide} centered>
			<Modal.Header>
				<Modal.Title>{translator('ChangePos')}</Modal.Title>
			</Modal.Header>
			{posId && (
				<Modal.Body>
					<div className='row'>
						<div className='col-lg-6'>
							<div className='form-group'>
								<label>{translator('ICT-number')}</label>
								<input
									className='form-control'
									name='inventoryNumber'
									defaultValue={defaultValues.ictNumber}
									ref={register({
										required: true,
										pattern: ictNumber,
										maxLength: 25,
										validate: () =>
											validationService.validatePosInventoryNumber(
												document.getElementsByName('inventoryNumber')[0].value,
												posId,
											),
									})}
								/>
								{errors.inventoryNumber &&
									errors.inventoryNumber.type === 'required' && (
										<p className='text-danger'>
											{translator('ValidationMsg-RequiredField')}
										</p>
									)}
								{errors.inventoryNumber &&
									errors.inventoryNumber.type === 'pattern' && (
										<p className='text-danger'>
											{translator('ValidationMsg-LettersAndNumbers')}
										</p>
									)}
								{errors.inventoryNumber &&
									errors.inventoryNumber.type === 'maxLength' && (
										<p className='text-danger'>
											{translator('ValidationMsg-MaxLength25')}
										</p>
									)}
								{errors.inventoryNumber &&
									errors.inventoryNumber.type === 'validate' && (
										<p className='text-danger'>
											{translator('ValidationMsg-ICTinUse')}
										</p>
									)}
							</div>
							<div className='form-group'>
								<label>{translator('POS-POSDetails-POSSerialNumber')}</label>
								<input
									className='form-control'
									name='posSerialNumber'
									defaultValue={defaultValues.posserialNumber}
									ref={register({
										required: true,
										pattern: numbersOnly,
										maxLength: 50,
										validate: () =>
											validationService.validatePosSerialNumber(
												document.getElementsByName('posSerialNumber')[0].value,
												posId,
											),
									})}
								/>
								{errors.posSerialNumber &&
									errors.posSerialNumber.type === 'required' && (
										<p className='text-danger'>
											{translator('ValidationMsg-RequiredField')}
										</p>
									)}
								{errors.posSerialNumber &&
									errors.posSerialNumber.type === 'pattern' && (
										<p className='text-danger'>
											{translator('ValidationMsg-NumbersOnly')}
										</p>
									)}
								{errors.posSerialNumber &&
									errors.posSerialNumber.type === 'maxLength' && (
										<p className='text-danger'>
											{translator('ValidationMsg-MaxLength50')}
										</p>
									)}
								{errors.posSerialNumber &&
									errors.posSerialNumber.type === 'validate' && (
										<p className='text-danger'>
											{translator('ValidationMsg-SerialNumberInUse')}
										</p>
									)}
							</div>
							{/* <div className="form-group">
                <label>TID</label>
                <input
                  className="form-control"
                  name="tid"
                  ref={register({
                    required: true,
                    maxLength: 25,
                    pattern: numbersOnly,
                    validate: () =>
                      validationService.validateTid(
                        document.getElementsByName("tid")[0].value,
                        posId
                      ),
                  })}
                />
                {errors.tid && errors.tid.type === "required" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}
                {errors.tid && errors.tid.type === "pattern" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-NumbersOnly")}
                  </p>
                )}
                {errors.tid && errors.tid.type === "maxLength" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-MaxLength25")}
                  </p>
                )}
                {errors.tid && errors.tid.type === "validate" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-TidInUse")}
                  </p>
                )}
              </div> */}
							<div className='form-group'>
								<label>MSISDN</label>
								<input
									type='text'
									name='msisdn'
									defaultValue={defaultValues.msisdn}
									className='form-control'
									ref={register({
										required: true,
										maxLength: 50,
									})}
								/>
								{/* <div className="row">
                  <div className="col-xs-12 col-sm-6 col-xl-3 pr-1 d-none d-sm-block">
                    <input
                      type="text"
                      className="form-control"
                      name="msisdnCountry"
                      defaultValue="+385"
                      disabled
                    />
                  </div>
                  <div className="col-xs-12 col-sm-6 col-xl-3 d-sm-none">
                    <input
                      type="text"
                      className="form-control"
                      name="msisdnCountry"
                      ref={register}
                      defaultValue="+385"
                      disabled
                    />
                  </div>

                  <div className="col-xs-12 col-sm-6 col-xl-4 pl-0 pr-0 d-none d-xl-block">
                    <select
                      name="msisdnPrefix"
                      ref={register({
                        validate: (value) => value !== "-1",
                      })}
                      className="form-control"
                    >
                      <option value="98">(0)98</option>
                      <option value="99">(0)99</option>
                    </select>
                  </div>
                  <div className="col-xs-12 col-xl-5 pl-1 d-none d-xl-block">
                    <input
                      type="number"
                      className="form-control"
                      ref={register({
                        required: true,
                        pattern: numbersOnly,
                        max: 99999999,
                      })}
                      name="msisdn"
                    />
                  </div>
                </div> */}
								{errors.msisdn && errors.msisdn.type === 'required' && (
									<p className='text-danger'>
										{translator('ValidationMsg-RequiredField')}
									</p>
								)}
							</div>
						</div>
						<div className='col-lg-6'>
							<div className='form-group'>
								<label>{translator('PosChangeReason-Label')}</label>
								<select
									ref={register({ required: true })}
									className='form-control'
									defaultValue={0}
									name='noteId'>
									<option value=''>{translator('Select-Reason')}</option>
									{reasons.map(reason => {
										return (
											<option
												key={reason.posLogReasonId}
												value={reason.posLogReasonId}>
												{translator(reason.reason)}
											</option>
										);
									})}
								</select>
								{errors.noteId && errors.noteId.type === 'required' && (
									<p className='text-danger'>
										{translator('ValidationMsg-RequiredField')}
									</p>
								)}
							</div>
							<div className='form-group'>
								<label>{translator('PosLogReason-Note')}</label>
								<textarea
									id='textArea'
									className='form-control'
									ref={register({
										maxLength: 200,
									})}
									rows={4}
									name='note'
								/>
								{errors.note && errors.note.type === 'maxLength' && (
									<p className='text-danger'>
										{translator('ValidationMsg-MaxLength200')}
									</p>
								)}
							</div>
							<div className='form-group'>
								<label className='labelCont'>
									<input
										type='checkbox'
										name='fiscalObligation'
										defaultChecked={generateNewActivationCode}
										onChange={() =>
											setGenerateNewActivationCode(!generateNewActivationCode)
										}
									/>
									<span className='checkmark'></span>
								</label>
								<span className='Data'>
									{translator('PosChange-generateNewActivationCode')}
								</span>
							</div>
						</div>
					</div>
				</Modal.Body>
			)}
			<Modal.Footer>
				<button
					type='button'
					className='btn btn-outline-secondary'
					data-dismiss='modal'
					onClick={handleHide}>
					{translator('General-Close')}
				</button>
				<button
					onClick={handleSubmit(confirmChange)}
					type='button'
					className='btn btn-primary'>
					{translator('Btn-Change')}
				</button>
			</Modal.Footer>
		</Modal>
	);
};

export default ChangePos;
